import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { generateChartData } from "./utils/function";

ChartJS.register(ArcElement, Tooltip, Legend);

interface PieChartI {
  chartData: any;
}

export function PieChart({ chartData = [] }: PieChartI) {


  console.log('the chart data are', chartData)

  if (!chartData || chartData?.length === 0) {
    return <p>No Match data are found</p>
  }

  const data = generateChartData(chartData)
  return <Pie data={data} />;
}